var map = {
	"./01.jpg": 85731,
	"./02.jpg": 23506,
	"./03.jpg": 7075,
	"./banner_img.png": 69585,
	"./design1.png": 81378,
	"./design2.png": 58257,
	"./featured_bg_shape.png": 80718,
	"./featured_img1.png": 17028,
	"./icon1.png": 8409,
	"./icon2.png": 32437,
	"./icon3.png": 76625,
	"./icon_shape.png": 35288,
	"./php.jpg": 77724,
	"./shap_tecture.png": 85346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63212;